import { render, staticRenderFns } from "./LotesCreateDragAndDrop.vue?vue&type=template&id=b3c9d91a&scoped=true"
import script from "./LotesCreateDragAndDrop.vue?vue&type=script&lang=js"
export * from "./LotesCreateDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./LotesCreateDragAndDrop.vue?vue&type=style&index=0&id=b3c9d91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c9d91a",
  null
  
)

export default component.exports